module.exports = __webpack_public_path__ + "6dd443ff28b2e082f707f574bada92ad.png";